import { render, staticRenderFns } from "./MiuTeacherService.vue?vue&type=template&id=eeb85fce&scoped=true"
import script from "./MiuTeacherService.vue?vue&type=script&lang=js"
export * from "./MiuTeacherService.vue?vue&type=script&lang=js"
import style0 from "./MiuTeacherService.vue?vue&type=style&index=0&id=eeb85fce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eeb85fce",
  null
  
)

export default component.exports